import { type ComponentProps } from 'react'
import { Elements, useStripe } from '@stripe/react-stripe-js'
import { useCheckout } from '../Checkout/CheckoutContext'
import { getStripePaymentOptions } from '../StripeElementsProvider/StripeElementsProvider'
import StripeExpressCheckout from './StripeExpressCheckout'
import ExpressCheckoutLoadingButton from './ExpressCheckoutLoadingButton'
import { useExpressCheckoutAvailability } from './ExpressCheckoutAvailabilityProvider'

function ExpressCheckoutButton(
  props: ComponentProps<typeof StripeExpressCheckout>
) {
  const stripe = useStripe()
  const { pricingSummary, isLoading } = useCheckout()
  const { isWalletUnavailable } = useExpressCheckoutAvailability()
  const paymentOptions = getStripePaymentOptions(pricingSummary)

  if (isWalletUnavailable) {
    return null
  }

  if (!stripe || (!paymentOptions && isLoading)) {
    return <ExpressCheckoutLoadingButton />
  }

  if (!paymentOptions) {
    return null
  }

  return (
    <Elements
      stripe={stripe}
      options={{
        ...paymentOptions,
        captureMethod: 'manual',
        appearance: { variables: { borderRadius: '10px' } },
      }}
    >
      <StripeExpressCheckout {...props} />
    </Elements>
  )
}

export default ExpressCheckoutButton
